import { render, staticRenderFns } from "./projectGoHelp.vue?vue&type=template&id=5f36c6b9&scoped=true"
import script from "./projectGoHelp.vue?vue&type=script&lang=js"
export * from "./projectGoHelp.vue?vue&type=script&lang=js"
import style0 from "./projectGoHelp.vue?vue&type=style&index=0&id=5f36c6b9&prod&lang=css"
import style1 from "./projectGoHelp.vue?vue&type=style&index=1&id=5f36c6b9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f36c6b9",
  null
  
)

export default component.exports